import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

// Helper to get token from either storage (migration support)
const getStoredToken = () => {
  return sessionStorage.getItem("token") || localStorage.getItem("token");
};

// Helper to clear auth data from both storages
const clearAuthStorage = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = getStoredToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Don't redirect on login failures — let Login.jsx handle the error
    const isLoginRequest = err.config?.url?.includes("/auth/login");
    if (err.response?.status === 401 && !isLoginRequest) {
      clearAuthStorage();
      window.location.href = "/login";
    }
    // Forced password change (2026-09): the backend now REFUSES every
    // endpoint for a flagged user with this machine-readable marker. Route
    // to the password screen from ANY surface — a flagged user with a
    // stale open tab gets redirected mid-session instead of stranded on a
    // generic error.
    if (
      err.response?.status === 403 &&
      err.response?.data?.detail === "password_change_required" &&
      window.location.pathname !== "/change-password"
    ) {
      window.location.href = "/change-password";
    }
    return Promise.reject(err);
  }
);
